__turbopack_context__.v({
  "container": "CallToCTA-module__6ytTaq__container",
  "content": "CallToCTA-module__6ytTaq__content",
  "iconBars": "CallToCTA-module__6ytTaq__iconBars",
  "step": "CallToCTA-module__6ytTaq__step",
  "steps": "CallToCTA-module__6ytTaq__steps",
  "title": "CallToCTA-module__6ytTaq__title",
});
